export default "//file.bilionpass.com/japandx-portal/0.1.21/static/img/service-hotel.622a1e74-1fb29d.png";